import { currentAuditEntryIdAtom, reportDemoModeAtom } from '@/global-store';
import { useAtom } from 'jotai';
import DomainSelect from './DomainSelect';
import { usePathname } from '@/hooks/usePathname';
import { type AuditData } from '@eye-able/types';

const GlobalDomainSelect = () => {
  const [auditEntryId, setAuditEntryId] = useAtom(currentAuditEntryIdAtom);
  const [reportDemoMode] = useAtom(reportDemoModeAtom);
  const path = usePathname();

  const handleSelect = (entry?: AuditData) => {
    const id = entry?.id;

    if (!id || id === auditEntryId) return;

    setAuditEntryId(id);
    let newPath;

    if (path.includes('/report/issues/issue')) {
      newPath = '/report/issues';
    } else if (path.includes('/report/pages/page')) {
      newPath = '/report/pages';
    } else if (path.includes('/report/analysis/lighthouse/page')) {
      newPath = '/report/analysis/lighthouse/';
    } else if (path.includes('/upload/pdf/')) {
      newPath = '/report/pdfs/upload';
    } else if (path.includes('/pdf/')) {
      newPath = '/report/pdfs/';
    }

    if (newPath) {
      return window.location.replace(newPath);
    }
  };

  if (reportDemoMode) {
    return <b>Demo Domain</b>;
  }

  return (
    <DomainSelect
      className='eye:max-sm:w-full eye:w-[350px]'
      initialEntryId={auditEntryId}
      onChange={handleSelect}
      fullWidth
      labelProps={{ labelFloatClassName: 'eye:bg-grey-10' }}
    />
  );
};

export default GlobalDomainSelect;
